import React, { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { DateUtils } from '@vectord/utils';

import { setSbatGroupDate } from 'features/classCreation';
import DateTimeInput from 'components/DateTimeInput';
import styles from './RescheduleClassDateTimeInput.module.scss';

function RescheduleClassDateTimeInput({ sbatGroup }) {
  const dispatch = useDispatch();

  const dateInputProps = useMemo(
    () => ({
      fromDate: new Date(),
      // Allow schedule till max next 6 months
      toDate: new Date(Date.now() + 180 * DateUtils.ONE_DAY),
    }),
    []
  );

  const timeInputProps = useMemo(
    () => ({
      menuPortalTarget: document.body,
      classNames: { menuPortal: () => styles.timeDropdown },
      maxMenuHeight: 150,
    }),
    []
  );

  const handleChange = useCallback(
    (newDate) => {
      dispatch(
        setSbatGroupDate({
          sbatGroupId: sbatGroup.id,
          dateOfTopic: newDate,
        })
      );
    },
    [dispatch, sbatGroup.id]
  );

  return (
    <DateTimeInput
      compact
      dateInputProps={dateInputProps}
      disabled={sbatGroup.locked}
      required
      timeInputProps={timeInputProps}
      onChange={handleChange}
      value={sbatGroup.newDateOfTopic}
      vertical
    />
  );
}

export default RescheduleClassDateTimeInput;
